import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mtm-download-upload-progress-icon',
  templateUrl: './mtm-download-upload-progress-icon.component.html',
  styleUrl: './mtm-download-upload-progress-icon.component.scss',
  standalone: false,
})
export class MTMDownloadUploadProgressIcon {
  @Input() isOnLoading: boolean = false;
  @Input() widthInPixel: any = 'auto';
  @Input() iconColor: any = 'white';

  constructor(private readonly elementRef: ElementRef) {}
}
